import React from "react";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import { documentStatus, getDocumentTranslator } from "./documentPopupMessages";

export default function POApprovalHistory({ runs = [] }) {
  const { languageId } = usePmsTheme();
  const es = languageId === "es";
  const t = getDocumentTranslator(languageId);
  const userLabel = (user, id) => user?.name || user?.email || (id ? `${es ? "Usuario" : "User"} #${id}` : "—");
  const date = (value) => value ? new Date(value).toLocaleString(es ? "es-ES" : "en-GB") : "—";
  if (!runs.length) return null;
  return <section className="eop-section" aria-label={es ? "Historial de aprobaciones" : "Approval history"}>
    <h6 className="eop-sectionTitle">{es ? "Historial de aprobaciones" : "Approval history"}</h6>
    {[...runs].sort((a, b) => Number(b.id) - Number(a.id)).map((run, index) => {
      const snapshot = run.document_snapshot;
      const withdrawal = run.status === "cancelled" && run.policy_snapshot?.withdrawal;
      const order = snapshot?.order;
      return <details key={run.id} open={index === 0} style={{ padding: "12px 0", borderBottom: "1px solid var(--pu-border)" }}>
        <summary style={{ cursor: "pointer" }}>
          {es ? "Ciclo" : "Cycle"} #{run.id} · {es ? "Versión" : "Version"} {run.document_revision ?? "—"} · {withdrawal ? t("Withdrawn from approval") : documentStatus(run.status, t)} · {date(run.created_at || run.started_at)}
        </summary>
        {run.submitted_by_user_id && <p>{es ? "Enviado por" : "Submitted by"} {userLabel(run.submitted_by, run.submitted_by_user_id)}</p>}
        {withdrawal && <p>{t("Recovered by")} {userLabel({ name: withdrawal.by_user_name }, withdrawal.by_user_id)} · {date(withdrawal.at)}</p>}
        {run.return_to_user_id && <p><strong>{es ? "Responsable de corregir" : "Responsible for correction"}: </strong>{userLabel(run.return_to, run.return_to_user_id)}</p>}
        {run.return_comment && <p style={{ whiteSpace: "pre-wrap" }}>
          <strong>{es ? "Devuelto por" : "Returned by"} {userLabel(run.returned_by, run.returned_by_user_id)} · {date(run.returned_at)}: </strong>{run.return_comment}
        </p>}
        <ul>{(run.tasks || []).map((task) => <li key={task.id}>
          {es ? "Nivel" : "Level"} {task.level_number ?? "—"} · {userLabel(task.approver, task.approver_user_id)} · {documentStatus(task.status, t)}
          {task.acted_at && ` · ${date(task.acted_at)}`}
          {task.notes && <p style={{ whiteSpace: "pre-wrap" }}>{task.notes}</p>}
        </li>)}</ul>
        {order ? <div>
          <p><strong>{snapshot.capture_reason === "legacy_return"
            ? (es ? "Capturado al devolver (documento anterior al historial de revisiones)" : "Captured on return (document predates revision history)")
            : snapshot.capture_reason === "legacy_recall" ? t("Captured on recovery (document predates revision history)")
            : (es ? "Documento presentado" : "Submitted document")}</strong> · {order.order_code} · {order.supplier_name || order.supplier_code || `#${order.supplier_id}`} · {order.total_amount ?? "—"} {order.currency || "EUR"}</p>
          {["legacy_return", "legacy_recall"].includes(snapshot.capture_reason) && snapshot.captured_at && <p>{date(snapshot.captured_at)}</p>}
          <p>{es ? "Entrega prevista" : "Expected delivery"}: {order.expected_delivery_date || "—"}</p>
          {order.notes && <p style={{ whiteSpace: "pre-wrap" }}>{order.notes}</p>}
          <div className="eop-tableWrap"><table className="eop-table">
            <thead><tr><th>{t("Item")}</th><th>{t("Quantity")}</th><th>{t("Unit Price")}</th><th>{t("Total")}</th></tr></thead>
            <tbody>{(snapshot.lines || []).map((line, index) => <tr key={line.id || index}>
              <td>{line.item_name || line.description || `#${line.item_id}`}</td>
              <td>{line.quantity}</td><td>{line.unit_price}</td><td>{line.total_price}</td>
            </tr>)}</tbody>
          </table></div>
        </div> : <p>{es ? "Este ciclo anterior no dispone de una copia de la versión presentada." : "This earlier cycle has no saved copy of the submitted version."}</p>}
      </details>;
    })}
  </section>;
}
